import React from 'react';
import { Countdown } from './Countdown';
import { ANCHOR_PRICE } from '../lib/config';
export function Urgency() {
  return <section className="w-full bg-ink py-16 sm:py-20" data-id="element-266" data-mp="2bvcwml61ownb">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-267" data-mp="1wzng32jmpbpz">
        <p className="text-[11px] uppercase tracking-[0.3em] text-gold" data-id="element-268" data-mp="1wz5c1jqq5t7i">
          Launch price — ends in
        </p>

        <div className="mt-8" data-id="element-269" data-mp="220b5jjs7lki3">
          <Countdown tone="dark" data-id="element-270" data-mp="1o6ju25ux3qjq" />
        </div>

        <p className="mt-8 text-base text-ivory/80" data-id="element-271" data-mp="1o5sbbvmf5nav">
          Then it goes back to the regular price of{' '}
          <span className="font-serif text-xl text-gold" data-id="element-272" data-mp="1szwfk74avh89">{ANCHOR_PRICE}</span>. For good.
        </p>

        <div className="mx-auto mt-10 max-w-md" data-id="element-273" data-mp="1e72qpv351oqx">
          <div className="h-1.5 w-full overflow-hidden bg-white/10" role="progressbar" aria-valuenow={88} aria-valuemin={0} aria-valuemax={100} aria-label="Launch-price spots taken" data-id="element-274" data-mp="1j91v98am6rpg">
            <div className="h-full bg-gold" style={{
            width: '88%'
          }} data-id="element-275" data-mp="25zad2rcl2mv8" />
          </div>
          <p className="mt-3 text-[11px] uppercase tracking-[0.16em] text-ivory/50" data-id="element-276" data-mp="2613jq6n75738">
            88% of launch-price spots already taken
          </p>
        </div>
      </div>
    </section>;
}